import { mapActions, mapMutations, mapState } from "vuex";
import DataSettings from "@/helpers/DataSettings";
import {
  SAVE_FILTER_OPEN,
  SAVE_LOADING_STEP,
  SAVE_TTC_COLOR_METRIC,
  //SAVE_WIKI_OPEN,
  TOGGLE_API_READY,
  TOGGLE_LOADING
} from "@/store/mutation-types";

export default {
  computed: {
    ...mapState({
      apiReady: state => state.api.apiReady,
      apiId: state => state.api.apiId,
      dataSettings: state => state.setting.dataSettings,
      importedFile: state => state.impexp.importedFile,
      filtersState: state => state.layout.filtersState,
      fieldsState: state => state.layout.fieldsState,
      ttcState: state => state.layout.ttcState,
      docsState: state => state.layout.docsState,
      docsDataState: state => state.layout.docsDataState,
      analysisState: state => state.layout.analysisState,
      favouritesState: state => state.layout.favouritesState,
      collectionsState: state => state.layout.collectionsState
    })
  },
  mounted() {
    if (this.apiReady) {
      return false;
    }
    //console.log(this.importedFile);
    if (!this.apiId) {
      this.saveApiId({ 
        apiId: localStorage.getItem("apiId"),
        currentModelName: localStorage.getItem("currentModelName"),
        currentDbType: localStorage.getItem("currentDbType")
      });
    }

    this.TOGGLE_LOADING({ loading: true });
    // Reset previous data
    // Fields view data
    this.saveVisData({});
    this.saveFieldRings(null);
    this.saveFieldTableTop(null);
    this.resetFilter();
    this.setChatbotThread(null);
    //const openFilters = localStorage.getItem(this.apiId + "_open_filters");
    //if (openFilters) {
    //  openFilters.split(",").forEach(filter => {
    //    this.SAVE_FILTER_OPEN({ filterId: filter });
    //  });
    //}

    /*const openWikis = localStorage.getItem(this.apiId + "_open_wikis");
    if (openWikis) {
      openWikis.split(",").forEach(wiki => {
        this.SAVE_WIKI_OPEN({ wikiId: wiki });
      });
    }*/

    this.loadSettings().then(() => {
      this.SAVE_LOADING_STEP({ loading_step: "Loading the model" });
      this.loadAPI().then(() => {
        //this.SAVE_LOADING_STEP({ loading_step: "Loading topics, themes and concepts" });
        
          this.loadTTC().then(() => {
            this.SAVE_LOADING_STEP({ loading_step: "Loading documents" });
            if(this.docsState){
              this.loadDocuments({
                which: "global",
                page: 1,
                pageSize: localStorage.getItem("explore-documents-per-page") || 10,
                sortOn: "pubdate",
                sortAsc: false
              }).then(() => {
                this.SAVE_LOADING_STEP({ loading_step: "Loading document graph" });
                this.loadDocumentsPerYear().then(() => {
                  this.SAVE_LOADING_STEP({ loading_step: "Loading analyses" });                 
                });
              });
              if(this.filtersState){
                this.loadFilters().then(() => {
                  if(this.collectionsState){
                    this.loadCollections().then(() => {
                      this.SAVE_LOADING_STEP({
                        loading_step: "Loading filters"
                      });
                      
                    });
                  }
                  if(this.favouritesState){
                    this.loadFavorites().then(() => {
                      this.SAVE_LOADING_STEP({
                        loading_step: "Loading collections"
                      });
                      
                    });
                  }
                  if(this.analysisState){
                    this.loadAnalyses().then(() => {
                      this.SAVE_LOADING_STEP({
                        loading_step: "Loading your favorites"
                      });
                      
                    });
                  }
                  this.getBatchingStatus(this.apiId).then(() => {
                    this.SAVE_LOADING_STEP({
                      loading_step: "Checking for batching status"
                    });
                  });
                  this.chatbotStatus({model_id : this.apiId}).then(() => {
                    this.SAVE_TTC_COLOR_METRIC({ ttc_color_metric: "recency" });
                    this.SAVE_LOADING_STEP({ loading_step: null });
                    this.TOGGLE_LOADING({ loading: false });
                    this.TOGGLE_API_READY({ api_ready: true });
                  })
                });
              }             
            }
          });
        
        
      });
    });
  },
  methods: {
    ...mapActions([
      "loadAnalyses",
      "loadAPI",
      "loadCollections",
      "loadDocuments",
      "loadDocumentsPerYear",
      "loadFavorites",
      "loadFilters",
      "loadTTC",
      "saveApiId",
      "loadDataSettings",
      "saveDataSettings",
      "saveVisData",
      "saveFieldRings",
      "saveFieldTableTop",
      "resetFilter",
      "saveImportFile",
      "chatbotStatus",
      "setChatbotThread",
      "getBatchingStatus"
    ]),
    ...mapMutations([
      SAVE_FILTER_OPEN,
      SAVE_LOADING_STEP,
      SAVE_TTC_COLOR_METRIC,
      //SAVE_WIKI_OPEN,
      TOGGLE_API_READY,
      TOGGLE_LOADING,
    ]),
    loadSettings() {
      return new Promise(resolve => {
        this.loadDataSettings().then(settings => {
          if(!this.importedFile || this.importedFile.status.settings){
            DataSettings.setSettings("root", settings);
          }
          else{
            if(this.importedFile){
              let imported = this.importedFile;
              this.saveDataSettings(this.importedFile.settings);
              imported.status.settings = true;
              this.saveImportFile(imported);
            }
          }
          // If present, resolve promise immediately
          resolve();
        });
      });
    }
  }
};
